export default __webpack_public_path__ + "static/media/Stack.83affc03.jpg";